import styled from '@emotion/styled';

export const ShippingInfoStyled = styled.div`
  border-top: 1px solid #ccc;
  display: flex;
  margin: 0 1rem 2rem;
`;

export const ShippingBlock = styled.div`
  border-right: 1px solid #ccc;
  padding: 0.5rem 1.5rem 3rem;
  width: 50%;

  &:last-child {
    border-right: none;
  }
`;

export const Title = styled.h2`
  font-size: 1.75rem;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
  display: inline-block;
  width: 100%;
`;

export const ShippingItem = styled.div`
  display: flex;

  span {
    display: inline-block;
    margin-bottom: 0.4rem;
    word-break: break-word;
  }

  span:first-of-type {
    font-weight: bold;
    min-width: ${({ smallLabel }) => (smallLabel ? '20%' : '50%')};
  }
`;

export const PackingItem = styled(ShippingItem)`
  margin-top: 1.5rem;
  flex-direction: column;
`;
